export default () => MESSAGES